import { useMemo } from "react";
import fetch from "unfetch";
import useSWR, { ConfigInterface } from "swr";
import { TilannekuvaCacheKeys } from "./cacheKey";
import { ITargetingScheme, TargetingSchemeMapper } from "../models/TargetingScheme";
import { IMap, MapMapper } from "../models/Map";

type TValue = {
    targetingScheme: ITargetingScheme;
    map: IMap
}

export type TUseTargetingSchemeHook = (referenceName: string, endpoint?: string, token?: string, config?: ConfigInterface<any>) => {
    data: TValue | null;
    fetching: boolean;
}

export const useTargetingScheme: TUseTargetingSchemeHook = (referenceName, endpoint, token, config = {}) => {


    const fetcher = async (): Promise<TValue | null> => {

        if (!endpoint || !token) {
            return null
        }

        try {
            const response = await fetch(endpoint, {
                method: "POST",
                body: JSON.stringify({
                    "action": "hae_kohdistusskema",
                    "kohdistusskema": { viitenimi: referenceName }
                }),
                headers: { "Authorization": "NAS SID " + token }
            });

            const json = await response.json();
            if (json.success === false) {
                throw Error(json)
            }

            return {
                targetingScheme: TargetingSchemeMapper.apiToDomain(json.kohdistusskema),
                map: MapMapper.apiToDomain(json.kartta)
            }
        } catch (error) {
            console.info(error)
            return null;
        }
    };

    const cacheKey = TilannekuvaCacheKeys.TargetingSchemeInstance(referenceName);

    const { data, isValidating } = useSWR(
        cacheKey,
        fetcher,
        {
            suspense: true,
            revalidateOnFocus: false,
            revalidateOnMount: false,
            revalidateOnReconnect: false,
            ...config
        }
    );


    const rawData = data ?? null;

    return useMemo(() => ({
        data: rawData,
        fetching: isValidating
    }), [rawData, isValidating]);
};
